export interface IRuntimeConfig {
  id?: number;
  key: string;
  value: string;
  type: RuntimeConfigType;
  description?: string;
  category: RuntimeConfigCategory;
  isSecret?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export type RuntimeConfigType = 'string' | 'number' | 'boolean' | 'json';
export type RuntimeConfigCategory = 
  | 'general'
  | 'session'
  | 'payment'
  | 'notification'
  | 'logging'
  | 'cleanup'
  | 'external_service'
  | 'security';

export interface ICreateRuntimeConfigDTO {
  key: string;
  value: string;
  type: RuntimeConfigType;
  description?: string;
  category: RuntimeConfigCategory;
  isSecret?: boolean;
}

export interface IUpdateRuntimeConfigDTO {
  value?: string;
  description?: string;
  isSecret?: boolean;
}

export const RuntimeConfigCategories: { value: RuntimeConfigCategory; label: string }[] = [
  { value: 'general', label: 'Generale' },
  { value: 'session', label: 'Sessioni' },
  { value: 'payment', label: 'Pagamenti' },
  { value: 'notification', label: 'Notifiche' },
  { value: 'logging', label: 'Logging' },
  { value: 'cleanup', label: 'Pulizia Dati' },
  { value: 'external_service', label: 'Servizi Esterni' },
  { value: 'security', label: 'Sicurezza' },
];

export const RuntimeConfigTypes: { value: RuntimeConfigType; label: string }[] = [
  { value: 'string', label: 'Testo' },
  { value: 'number', label: 'Numero' },
  { value: 'boolean', label: 'Booleano' },
  { value: 'json', label: 'JSON' },
];
